import { RolesMap } from '@/models/user'
import { RouteRecordRaw } from 'vue-router'
import SubcontractorModule from './SubcontractorModule.vue'
import ListSubcontractors from './views/ListSubcontractors.vue'
import CreateSubcontractor from './views/CreateSubcontractor.vue'
import ShowSubcontractor from './views/ShowSubcontractor.vue'
import EditSubcontractor from './views/EditSubcontractor.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/subs',
    component: SubcontractorModule,
    meta: { authorize: [RolesMap.EMPLOYEE_ROLE] },
    children: [
      {
        path: '',
        name: 'ListSubcontractors',
        component: ListSubcontractors,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'new',
        name: 'CreateSubcontractor',
        component: CreateSubcontractor,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: ':id',
        name: 'ShowSubcontractor',
        component: ShowSubcontractor,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: ':id/edit',
        name: 'EditSubcontractor',
        component: EditSubcontractor,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      }
    ]
  }
]

export default routes
